import React, { Component } from 'react';
import { browserName, browserVersion } from 'react-device-detect';
import moment from 'moment';
import { Table, Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, FormGroup, Label, FormText, Alert} from 'reactstrap';
import { infinity, pulsar } from 'ldrs'
import { GiHelp } from 'react-icons/gi'
import { connect } from 'react-redux';

infinity.register()
pulsar.register()

class DPRAdvisor extends Component {
    static displayName = DPRAdvisor.name;

    constructor(props) {
        super(props);
        this.state = {
            returnable: this.props.reduxData.userInfo,
            reportLoading: false,
            studentsLoading: true,
            permissionFlag: true,
            browser: `${browserName}${browserVersion}`,
            ip: "",
            headerMain: [],
            headerNotes: [],
            coreData: [],
            majorData: [],
            warningModal: true,
            findThisStudent: "",
            studentName: "",
            pcidInfo: false,
            notAStudent: false
        }
        this.testPermission();
    }

    async getUserInfo() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            returnable: data
        }, () => {
            
            //this.getHeaderData();
        })
        
    }

    async testPermission() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pagepk: "/DPRAdvisor"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.props.updateFetchTime();
        this.setState({
            permissionFlag: data
        })
    }

    componentDidMount() {

    }

    async getStudents(e) {
        
        this.setState({
            findThisStudent: e.target.value
        })
        if (this.state.notAStudent) {
            this.setState({
                notAStudent: false
            })
        }
        
        if (e.target.value.length < 10) {
            
            this.setState({
                studentName: ""
            })
        }
        if (e.target.value.length == 10) {
            
            //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
            let bearerVAR = "Bearer " + this.props.reduxData.apiKey
            let toSend = {
                userLevel: this.props.reduxData.userInfo.level.pk,
                pcid: e.target.value
            }
            const response = await fetch('DPRAdvisorStudentList', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            })
            const data = await response.json();
            //localStorage.setItem("lastFetch", moment());
            this.props.updateFetchTime()
            this.setState({
                studentName: data.stuname
            })
        }
        
    }

    async getHeaderData() {
        this.setState({
            studentsLoading: false,
            reportLoading: true
        })
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pcid: this.state.findThisStudent
        }
        const response = await fetch('DPRAdvisor_HeaderData', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        if (data.length > 0) {
            this.setState({
                headerMain: data,
            }, () => { this.getHeaderNotes(); })
        }
        else {
            this.setState({
                notAStudent: true,
                findThisStudent: "",
                reportLoading: false,
                studentsLoading: true,
                studentName: ""
            })
        }
        //localStorage.setItem("lastFetch", moment());
        this.props.updateFetchTime();

    }

    async getHeaderNotes() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pcid: this.state.findThisStudent
        }
        const response = await fetch('DPRAdvisor_HeaderNotes', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            headerNotes: data,
        }, () => { this.getCore(); })
        //localStorage.setItem("lastFetch", moment());
        this.props.updateFetchTime()

    }

    async getCore() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pcid: this.state.findThisStudent
        }
        const response = await fetch('DPRAdvisor_Core', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            coreData: data
        }, () => { this.getMajor(); })
        //localStorage.setItem("lastFetch", moment());
        this.props.updateFetchTime()
    }

    async getMajor() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pcid: this.state.findThisStudent
        }
        const response = await fetch('DPRAdvisor_Major', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            majorData: data,
            reportLoading: false
        })
        //localStorage.setItem("lastFetch", moment());
        this.props.updateFetchTime()
    }

    header() {
        return (
            <div>
                <Table borderless>
                    <tbody>
                        <tr>
                            <td className="eightyNoBlock"><h2>{this.state.headerMain[0].lastname}, {this.state.headerMain[0].firstname} {this.state.headerMain[0].middlename} ({this.state.headerMain[0].pcid})</h2></td>
                            <td><b>Overall GPA: {this.state.headerMain[0].gpa}</b></td>
                        </tr>
                    </tbody>
                </Table>
                <Table borderless>
                    <tbody>
                        <tr>
                            <td><b>Cohort: {this.state.headerMain[0].catalogyear} {this.state.headerMain[0].catalogterm}</b></td>
                            <td><b>Matric: {this.state.headerMain[0].matricyear} {this.state.headerMain[0].matricterm}</b></td>
                            <td><b>Expect Grad: {this.state.headerMain[0].expectgrad}</b></td>
                            <td><b>Earned Credits: {this.state.headerMain[0].earnedcredits}</b></td>
                        </tr>
                    </tbody>
                </Table>
                <div className="eightyPercent">
                    <span style={{ color: "blue" }}>{this.state.headerMain[0].currcode.substring(0, 5) != "MJNUR" ? "Undergraduate" : "Nursing"} Requirements: </span><br />
                    <span style={{ color: "#e74C3C" }}>{this.state.headerMain[0].currcode.substring(0, 5) != "MJNUR"
                        ? "Minimum 124 credits (100-level or above) required for graduation, CUM GPA of 2.0, and Major GPA Requirements (Click on Undergrad Requirements)"
                        : "Minimum 124 credits (100-level or above) required for graduation, Composite GPA of 2.75, and a grade of C or higher in all Nursing and nursing-required classes."}</span>
                </div>
                <div className="twentyPercent" style={{ color: "#4169e1" }}><b><u>Composite GPA: {this.state.headerMain[0].compositegpa}</u></b></div><br /><br />
                <div className="twentyPercent rightAlignCustom" style={{ color: "blue", cursor: "pointer" }} onClick={() => window.open("http://hood.smartcatalogiq.com/", '_blank').focus()}><b>Click to View Catalog</b></div>
                <br />
                <Table bordered>
                    <thead style={{ backgroundColor: "#00a9d3", color: "#ffffff" }}>
                        <tr>
                            <th>Degree</th>
                            <th>Major</th>
                            <th>Advisor</th>
                            <th>Major GPA</th>
                            <th>Non Trad</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.headerMain.map(item => (
                            <tr>
                                <td>{item.degree}</td>
                                <td>{item.curriculum}</td>
                                <td>{item.advisorfirst} {item.advisorlast}</td>
                                <td>{item.majorgpa}</td>
                                <td>{item.nontrad}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                <br />
                <div className="centerDiv"><b>Notes</b></div>
                <Table>
                    <thead>
                        <tr>
                            <td className="oneThird"></td>
                            <td className="oneThird"></td>
                            <td className="oneThird"></td>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.headerNotes.length > 0 ? this.state.headerNotes.map(item => (
                            <tr>
                                <td>{item.type}</td>
                                <td>{item.note.split('\r\n').map(str => <div>{str}<br /></div>)}</td>
                                <td>{item.date}</td>
                            </tr>)) : <tr><td className="oneThird">&ensp;</td><td className="oneThird"><div className="centerDiv">No Notes on File</div></td><td className="oneThird">&ensp;</td></tr>}
                    </tbody>
                </Table>
            </div>
        );
    }

    core() {
        let firstSplit = Object.groupBy(this.state.coreData, ({ bracket }) => bracket)
        let secondSplit;
        let fullList = [];
        for (var key in firstSplit) {
            var obj = firstSplit[key];
            let bracketList = [];
            secondSplit = Object.groupBy(obj, ({ heading1 }) => heading1)
            for (var secondKey in secondSplit) {
                var secondObj = secondSplit[secondKey];
                bracketList.push({ secondKey, secondObj })
            }
            fullList.push({ key, bracketList })
        }
        return (<div>
            <h3 style={{ color: "#4682b4 " }}><b>Core Curriculum</b></h3>
            {fullList.map(bracketKey => (
                <div><div style={{ backgroundColor: "#000000", color: "#ffffff" }}>{bracketKey.key}</div>
                    <div><div style={{ backgroundColor: "#696969", color: "#ffffff" }} className="twentyPercent">Requirements</div><div style={{ backgroundColor: "#00A9D3", color: "#ffffff" }} className="eightyPercent">Taken Courses</div></div>
                    {bracketKey.bracketList.map(listItem => (
                        <div>
                            <div><div style={{ backgroundColor: "#00A9D3", color: "#ffffff" }} className="sixtyPercent">{listItem.secondKey}</div><div style={{ backgroundColor: "#00A9D3", color: listItem.secondObj[0].fulfillment == "" ? "#00a9d3" : "#ffffff" }} className="fortyPercent">{listItem.secondObj[0].fulfillment}&ensp;</div></div>
                            <div style={{ backgroundColor: "#696969", color: "#ffffff" }}>{listItem.secondObj[0].heading2.split("<br/>").map(str => <div>{str}<br /></div>)}</div>
                            <Table bordered>
                                <thead>
                                    <tr>
                                        <th className="tenPercent" style={{ backgroundColor: "#696969", color: "#ffffff" }}>Course</th>
                                        <th className="tenPercent" style={{ backgroundColor: "#696969", color: "#696969" }}>Operand</th>

                                        <th className="fortyPercent" style={{ backgroundColor: "#00A9D3", color: "#ffffff" }}>Course</th>
                                        <th className="tenPercent" style={{ backgroundColor: "#00A9D3", color: "#00a9d3" }}>Operand</th>
                                        <th className="fifteenPercent" style={{ backgroundColor: "#00A9D3", color: "#ffffff" }}>Term</th>
                                        <th className="fivePercent" style={{ backgroundColor: "#00A9D3", color: "#ffffff" }}>Credit</th>
                                        <th className="tenPercent" style={{ backgroundColor: "#00A9D3", color: "#ffffff" }}>Grade</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listItem.secondObj.map(classItem => (
                                        <tr>
                                            <td className="tenPercent">{classItem.fulfillment == "" ? classItem.openparen + classItem.reqeventid + classItem.closeparen : ""}</td>
                                            <td className="tenPercent">{classItem.operand}</td>
                                            <td className="fortyPercent">{classItem.takeneventid} {classItem.takeneventname != "" ? "- " + classItem.takeneventname : ""}</td>
                                            <td className="tenPercent">{classItem.takeneventsubtype}</td>
                                            <td className="fifteenPercent">{classItem.takenyear} {classItem.takenterm}</td>
                                            <td className="fivePercent">{classItem.credit}</td>
                                            <td className="tenPercent">{classItem.gr}</td>
                                        </tr>))}
                                </tbody>
                            </Table>
                        </div>
                    ))}

                </div>
            ))}
        </div>
        )

    }

    major() {
        let degprintorderSplit = Object.groupBy(this.state.majorData, ({ degree }) => degree)
        let degreeSplit;
        let primaryDeg = this.state.majorData.filter(obj => { return obj.degprintorder == "1" })[0].degree
        let finalList = []
        for (var key in degprintorderSplit) {
            var obj1 = degprintorderSplit[key];
            let dpoList = [];
            degreeSplit = Object.groupBy(obj1, ({ heading1 }) => heading1)
            for (var degKey in degreeSplit) {
                var obj2 = degreeSplit[degKey]
                dpoList.push({ degKey, obj2 })
            }
            finalList.push({ key, dpoList })
        }
        return (<div>
            {finalList.map(item => (<div>
                <h3 style={{ color: "#4682b4 " }}><b>{item.key == primaryDeg ? "Primary" : "Secondary"} Degree Curriculum: {item.key} {item.dpoList[0].obj2[0].curr}</b></h3>
                {item.dpoList.filter((countNonBlanks) => countNonBlanks.degKey != "").length > 0 ? <div><div>{item.dpoList.filter((blank) => blank.degKey == "")[0].obj2.filter((note) => note.eventclass.substring(note.eventclass.length - 4, note.eventclass.length) == "NOTE")[0].notes.replace("NONE", "")}</div><p />
                    {item.dpoList.filter((noBlank) => noBlank.degKey != "").map(obj => (
                        <div>
                            <div style={{ backgroundColor: "#000000", color: "#ffffff" }}>{obj.degKey}</div>
                            <div style={{ backgroundColor: "#696969", color: "#ffffff" }}>{obj.obj2[0].heading2}</div>
                            <div>
                                <div style={{ backgroundColor: "#696969", color: "#ffffff" }} className="twentyPercent"><b>Requirements</b></div>
                                <div style={{ backgroundColor: "#00A9D3", color: "#ffffff" }} className="eightyPercent"><b>Taken Courses</b></div>
                            </div>
                            <Table>
                                <thead>
                                    <tr>
                                        <th className="tenPercent" style={{ backgroundColor: "#696969", color: "#ffffff" }}>Course</th>
                                        <th className="tenPercent" style={{ backgroundColor: "#696969", color: "#696969" }}>Operand</th>

                                        <th className="fortyPercent" style={{ backgroundColor: "#00A9D3", color: "#ffffff" }}>Course</th>
                                        <th className="tenPercent" style={{ backgroundColor: "#00A9D3", color: "#00a9d3" }}>Operand</th>
                                        <th className="fifteenPercent" style={{ backgroundColor: "#00A9D3", color: "#ffffff" }}>Term</th>
                                        <th className="fivePercent" style={{ backgroundColor: "#00A9D3", color: "#ffffff" }}>Credit</th>
                                        <th className="tenPercent" style={{ backgroundColor: "#00A9D3", color: "#ffffff" }}>Grade</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {obj.obj2.map(itemTaken => (<tr>
                                        <td className="tenPercent">{itemTaken.reqeventid == "" ? <div>&ensp;</div> : itemTaken.reqeventid}</td>
                                        <td className="tenPercent">{itemTaken.operand == "" ? <div>&ensp;</div> : itemTaken.operand}</td>
                                        <td className="fortyPercent">{itemTaken.takeneventid == "" ? <div>&ensp;</div> : itemTaken.takeneventid}</td>
                                        <td className="tenPercent">{itemTaken.takeneventsubtype == "" ? <div>&ensp;</div> : itemTaken.takeneventsubtype}</td>
                                        <td className="fifteenPercent">{itemTaken.takenyear == "" ? <div>&ensp;</div> : itemTaken.takenyear} {itemTaken.takenterm == "" ? <div></div> : itemTaken.takenterm} </td>
                                        <td className="fivePercent">{itemTaken.credit == "" ? <div>&ensp;</div> : itemTaken.credit}</td>
                                        <td className="tenPercent">{itemTaken.gr == "" ? <div>&ensp;</div> : itemTaken.gr}</td>
                                    </tr>))}
                                </tbody>
                            </Table>

                        </div>
                    ))}
                    <br />
                    <div style={{ backgroundColor: "#000000", color: "#ffffff" }}>Other Courses Taken Towards Major</div>
                    <div style={{ backgroundColor: "#696969", color: "#696969" }}>Courses:</div>
                    <div>
                        <div style={{ backgroundColor: "#696969", color: "#696969" }} className="twentyPercent">Requirements</div>
                        <div style={{ backgroundColor: "#00A9D3", color: "#ffffff" }} className="eightyPercent"><b>Taken Courses</b></div>
                    </div>
                    <Table>
                        <thead>
                            <tr>
                                <th className="tenPercent" style={{ backgroundColor: "#696969", color: "#696969" }}>Course</th>
                                <th className="tenPercent" style={{ backgroundColor: "#696969", color: "#696969" }}>Operand</th>

                                <th className="fortyPercent" style={{ backgroundColor: "#00A9D3", color: "#ffffff" }}>Course</th>
                                <th className="tenPercent" style={{ backgroundColor: "#00A9D3", color: "#00a9d3" }}>Operand</th>
                                <th className="fifteenPercent" style={{ backgroundColor: "#00A9D3", color: "#ffffff" }}>Term</th>
                                <th className="fivePercent" style={{ backgroundColor: "#00A9D3", color: "#ffffff" }}>Credit</th>
                                <th className="tenPercent" style={{ backgroundColor: "#00A9D3", color: "#ffffff" }}>Grade</th>
                            </tr>
                        </thead>
                        <tbody>
                            {item.dpoList.filter((forBlank) => forBlank.degKey == "")[0].obj2.filter((forOther) => forOther.eventclass.substring(forOther.eventclass.length - 5, forOther.eventclass.length) == "OTHER").map(otherItem => (<tr>
                                <td className="tenPercent">{otherItem.reqeventid == "" ? <div>&ensp;</div> : otherItem.reqeventid}</td>
                                <td className="tenPercent">{otherItem.operand == "" ? <div>&ensp;</div> : otherItem.operand}</td>
                                <td className="fortyPercent">{otherItem.takeneventid == "" ? <div>&ensp;</div> : otherItem.takeneventid}</td>
                                <td className="tenPercent">{otherItem.takeneventsubtype == "" ? <div>&ensp;</div> : otherItem.takeneventsubtype}</td>
                                <td className="fifteenPercent">{otherItem.takenyear == "" ? <div>&ensp;</div> : otherItem.takenyear} {otherItem.takenterm == "" ? <div></div> : otherItem.takenterm}</td>
                                <td className="fivePercent">{otherItem.credit == "" ? <div>&ensp;</div> : otherItem.credit}</td>
                                <td className="tenPercent">{otherItem.gr == "" ? <div>&ensp;</div> : otherItem.gr}</td>
                            </tr>))}
                        </tbody>
                    </Table>
                    <br />
                    <div style={{ backgroundColor: "#000000", color: "#ffffff" }}>Repeated Courses Taken Towards Major</div>
                    <div style={{ backgroundColor: "#696969", color: "#696969" }}>Courses:</div>
                    <div>
                        <div style={{ backgroundColor: "#696969", color: "#696969" }} className="twentyPercent">Requirements</div>
                        <div style={{ backgroundColor: "#00A9D3", color: "#ffffff" }} className="eightyPercent"><b>Taken Courses</b></div>
                    </div>
                    <Table>
                        <thead>
                            <tr>
                                <th className="tenPercent" style={{ backgroundColor: "#696969", color: "#696969" }}>Course</th>
                                <th className="tenPercent" style={{ backgroundColor: "#696969", color: "#696969" }}>Operand</th>

                                <th className="fortyPercent" style={{ backgroundColor: "#00A9D3", color: "#ffffff" }}>Course</th>
                                <th className="tenPercent" style={{ backgroundColor: "#00A9D3", color: "#00a9d3" }}>Operand</th>
                                <th className="fifteenPercent" style={{ backgroundColor: "#00A9D3", color: "#ffffff" }}>Term</th>
                                <th className="fivePercent" style={{ backgroundColor: "#00A9D3", color: "#ffffff" }}>Credit</th>
                                <th className="tenPercent" style={{ backgroundColor: "#00A9D3", color: "#ffffff" }}>Grade</th>
                            </tr>
                        </thead>
                        <tbody>
                            {item.dpoList.filter((forBlank) => forBlank.degKey == "")[0].obj2.filter((forOther) => forOther.eventclass.substring(forOther.eventclass.length - 6, forOther.eventclass.length) == "REPEAT").map(otherItem => (<tr>
                                <td className="tenPercent">{otherItem.reqeventid == "" ? <div>&ensp;</div> : otherItem.reqeventid}</td>
                                <td className="tenPercent">{otherItem.operand == "" ? <div>&ensp;</div> : otherItem.operand}</td>
                                <td className="fortyPercent">{otherItem.takeneventid == "" ? <div>&ensp;</div> : otherItem.takeneventid}</td>
                                <td className="tenPercent">{otherItem.takeneventsubtype == "" ? <div>&ensp;</div> : otherItem.takeneventsubtype}</td>
                                <td className="fifteenPercent">{otherItem.takenyear == "" ? <div>&ensp;</div> : otherItem.takenyear} {otherItem.takenterm == "" ? <div></div> : otherItem.takenterm}</td>
                                <td className="fivePercent">{otherItem.credit == "" ? <div>&ensp;</div> : otherItem.credit}</td>
                                <td className="tenPercent">{otherItem.gr == "" ? <div>&ensp;</div> : otherItem.gr}</td>
                            </tr>))}
                        </tbody>
                    </Table>
                </div> : <div><b>Online progress display for this major has not been completed.  Please check back later.</b></div>}
            </div>
            ))}
        </div>)
    }

    flip() {
        this.setState({
            warningModal: !this.state.warningModal
        })
    }

    flipInfoPCID() {
        this.setState({
            pcidInfo: !this.state.pcidInfo
        })
    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        //if (this.props.justSwitch == true) {
        //    this.props.passNewPage(1);
        //}
        let pageDisplay = <div></div>
        if (this.state.studentsLoading) {
            pageDisplay = <div className="halfOfParent">
            <FormGroup floating>
                    <Input type="text" id="pcid" name="pcid" placeholder="Student PCID" onChange={(e) => this.getStudents(e)} value={this.state.findThisStudent}></Input>
                    <Label for="pcid">Student PCID</Label>
                    <a href="#" onClick={(e) => { this.flipInfoPCID(); e.preventDefault() } }><GiHelp /></a>&ensp;&ensp;
                    <FormText>{this.state.studentName}</FormText>
                </FormGroup>
                <Button type="submit" onClick={this.getHeaderData.bind(this)} color="success">Go</Button>
                <br />
                {this.state.notAStudent && <Alert color="danger">This is not a student, or no DPR is available for them. Please try again.</Alert>}
            </div>
        }
        if (this.state.reportLoading) {
            pageDisplay = <l-infinity size="65" stroke="4" stroke-length="0.15" bg-opacity="0.27" speed="1.3" color="#86d3ff" />
        }
        if (this.state.majorData.length > 0) {
            pageDisplay = <div>
                <div className="rightAlignCustom"><Button onClick={() => this.setState({
                    majorData: [],
                    headerData: [],
                    coreData: [],
                    studentsLoading: true,
                    findThisStudent: "",
                    studentName: ""
                })}>Go Back</Button></div>
                        {this.header()}<br />
                        {this.core()}<br />
                        {this.major()}<br />
                    </div>
        }
        //let pageDisplay = <div></div>
        //if (this.state.reportLoading) { pageDisplay = <l-infinity size="65" stroke="4" stroke-length="0.15" bg-opacity="0.27" speed="1.3" color="#86d3ff" /> }
        //if (!this.state.loading) {
        //    if (this.state.majorData.length > 0) {
        //        pageDisplay = <div>
        //            {this.header()}<br />
        //            {this.core()}<br />
        //            {this.major()}<br />
        //        </div>
        //    }
        //}
        //toggle={this.flip.bind(this)}
        return (<div>
            <Modal isOpen={this.state.pcidInfo} >
                <ModalHeader>
                    What is a PCID?
                </ModalHeader>
                <ModalBody>
                    A People Code ID, or PCID, is the identifier that all employees and students are given when using College information systems. Each PCID is unique to the individual. To run a student’s DPR, a PCID must be entered to select the correct student and to display the correct student’s academic information within the DPR.<p />
                    A student's PCID is commonly found in the raw ID form, as a series of nine numbers. This can be found in Self-Service beneath the student's name in the Advisee Management search, or on the student's ID card itself.<p />
                    In both cases, you must preface this numerical string with a letter "P" to turn this ID number into a valid PCID.<p />
                    For example, <strong><span style={{ color: "#86d3ff" }}>P123456789</span></strong> would represent a valid PCID. Note that P123456789 is currently not used in the system.
                </ModalBody>
                <ModalFooter>
                    <Button onClick={this.flipInfoPCID.bind(this) }>Got it</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={this.state.warningModal} >
                <ModalHeader >
                    <b>Dear Advisors:</b>
                </ModalHeader>
                <ModalBody>
                    <span style={{ color: "#e74C3C" }}><b>Changes are here!</b></span><p />
                    Please be advised that the efforts of building Academic Plans in Self-Service for all Hood undergraduate students were successful. <span style={{ textDecoration: "underline", color: "#FF0000" }}><strong>This Degree Progress Report is no longer being updated or supported</strong></span>,
                    so please be sure to login to Self-Service to see your degree progress requirements (academic plans) moving forward. <p />
                    Academic Plans run much faster, allow you to conduct “What Ifs” with different academic program requirements, are available on any device including mobile and are accessible from on or off campus.<p />
                    Thank you for your time and attention!
                </ModalBody>
                <ModalFooter>
                    <Button onClick={this.flip.bind(this)}>Ok</Button>
                </ModalFooter>
            </Modal>
            {pageDisplay}
        </div>);
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(DPRAdvisor);